import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { CurrentService } from '../../../../services/current.service';
import { DatasService } from '../../../../services/datas.service';
import { HbmIframeService } from '../../../../services/hbm/hbm-iframe.service';
import { Router } from '@angular/router';
import { GTM } from 'src/app/services/gtm.service';
import { getHbmTotalSteps } from 'src/app/services/helpers/app-context-helper';
import { CustomerService } from 'src/app/services/customer.service';
import { TunnelNavigationStore } from '../../../../stores/tunnel/tunnel-navigation.store';
import { TunnelDataStore } from 'src/app/stores/tunnel/tunnel-data.store';
import { CONFIG_CONTEXT } from 'src/app/enum/config-context.enum';
import { StorageConfigurationData } from 'src/app/stores/tunnel/model/configuration-data/storage-configuration-data';
import { StorageInspiration } from 'src/app/models/configurators-2d/tunnel/storage/storage-tunnel-dtos';

@Component({
  selector: 'ng-casto-storage-recap',
  templateUrl: './recap.component.html',
})
export class StorageRecapComponent implements OnInit {
  @Output() onBackToStep: EventEmitter<number> = new EventEmitter();

  public currentInspiration;
  public currentBox;
  public currentFront;
  public currentHandles;
  public currentLegs;

  private _currentTargetProjectUuid: string;

  constructor(
    public current: CurrentService,
    public datas: DatasService,
    private readonly gtm: GTM,
    public tunnelDataStore: TunnelDataStore,
    private readonly byMe: HbmIframeService,
    private readonly router: Router,
    private readonly customer: CustomerService,
    private readonly tunnelNavigationStore: TunnelNavigationStore
  ) { }

  ngOnInit(): void {
    this.gtm.trackPage(`${this.router.url}/choix/synthese`, 'Rangements | Choix', {
      stepNumber: 6,
      totalSteps: getHbmTotalSteps(this.customer.context),
    });

    this.currentInspiration = this.datas.storage.inspirations.find(item => item.id === this.current.storage.inspirationId);
    this.currentBox = this.datas.storage.boxes.find(item => item.id === this.current.storage.boxId);
    this.currentFront = this.datas.storage.fronts.find(item => item.id === this.current.storage.frontId);
    this.currentHandles = this.datas.storage.handles.find(item => item.id === this.current.storage.handlesId);
    this.currentLegs = this.datas.storage.legs.find(item => item.id === this.current.storage.legsId);

    let _declination: any = this.datas.storage.inspirationDeclinations.find((row: any) => {
      if (row.iId !== this.current.storage.inspirationId) return false;
      if (row.bId !== this.current.storage.boxId) return false;
      if (row.fId !== this.current.storage.frontId) return false;
      if (row.hId !== this.current.storage.handlesId) return false;
      return row.lId === this.current.storage.legsId;
    });

    if (_declination) {
      this._currentTargetProjectUuid = _declination.pUuid;
    }
  }

  backToStep(step: number) {
    this.onBackToStep.emit(step);
  }

  start() {
    this.byMe.prepareBymeSettingsForLoadingStorageInspiration(this._currentTargetProjectUuid);
    const configurationData = this.tunnelDataStore.getCurrentStateValue().configurationData;
    let storageConfiguration = configurationData.get(CONFIG_CONTEXT.STORAGE) as StorageConfigurationData;

    if (!storageConfiguration) {
      storageConfiguration = new StorageConfigurationData();
    }

    if (!storageConfiguration.inspiration) {
      storageConfiguration.inspiration = {
        inspirationId: null,
        legsId: null,
        frontId: null,
        boxId: null,
        handlesId: null,
      } as StorageInspiration;
    }

    storageConfiguration.inspiration.inspirationId = this.current.storage.inspirationId;
    storageConfiguration.inspiration.boxId = this.current.storage.boxId;
    storageConfiguration.inspiration.frontId = this.current.storage.frontId;
    storageConfiguration.inspiration.handlesId = this.current.storage.handlesId;
    storageConfiguration.inspiration.legsId = this.current.storage.legsId;

    this.tunnelDataStore.updateConfigurationData(CONFIG_CONTEXT.STORAGE, storageConfiguration);

    this.next();
  }

  private next() {
    if (this.tunnelNavigationStore.isTunnelValue) {
      this.nextTunnel();
    } else {
      this.nextClassic();
    }
  }

  private nextTunnel() {
    this.tunnelNavigationStore.nextStep();
  }

  private nextClassic() {
    this.router.navigate(['rangements', 'configuration']);
  }
}
